export default "__VITE_ASSET__d31fbadc__"